import React from "react";
import { getMgmtTodays } from "../../../models/management";
import i18n from "../../../i18n";
import { MzadLoader } from "../../helpers/mzadLoader";
import { Modal } from "react-bootstrap";
import ListAucsTable from "./list_aucs";
import { getAllBidders, getAuctions } from "../../../models/auctions";
import { SaudiRiyalLogo } from "../../logo/saudiLogo";

export class DashboardTodays extends React.Component {
  constructor() {
    super();
    this.state = {
      is_loading: false,
      auctions: [],
      groups: [],
      groups_data: [],
      selected_group: {},
      group_total: 0,
      client: "",
      end_time: "",
      open_approve_popup: false,
      is_loading_aucs: false,
      selected_id: null,
      selectedRows: [],
      group_info: {},
      pm_entries: null,
      open_bidder_popup: false,
      bidders: [],
    };
    this.openBiddersPopup = this.openBiddersPopup.bind(this);
  }

  componentDidMount() {
    this.getTodaysList();
  }

  async openBiddersPopup(item) {
    this.setState({ bidders: {}, bidder_loader: true });
    const response = await getAllBidders({ group: item?.id });
    let bidders = response.data;
    if (bidders && bidders.length > 0) {
      this.setState({ open_bidder_popup: true, bidders, bidder_loader: false });
    }
  }

  async getTodaysList() {
    this.setState({ is_loading: true });
    try {
      const response = await getMgmtTodays();
      if (response.success) {
        this.setState({
          is_loading: false,
          groups: response.data,
          groups_data: response.data,
        });
      }
    } catch (error) {
      this.setState({ is_loading: false });
    }
  }

  handleFilterChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value }, this.filterData);
  };

  filterData = () => {
    const { groups_data, client, end_time } = this.state;
    let filtered = groups_data;

    if (client) {
      filtered = filtered.filter(
        (item) => Number(item.organization) === Number(client)
      );
    }

    if (end_time) {
      filtered = filtered.filter((item) => {
        // Compare dates in YYYY-MM-DD format
        const itemDate = new Date(item.end_date).toISOString().split("T")[0];
        return itemDate === end_time;
      });
    }

    this.setState({ groups: filtered });
  };

  loadAllAuctions = async (params, isFundPopup = false) => {
    this.setState({ is_loading_aucs: true, auctions: [] });
    try {
      const response = await getAuctions("?is_client=1&" + params);
      if (response) {
        this.setState({
          auctions: response.data,
          is_loading_aucs: false,
          group_info: response.meta?.group || {},
          group_total: response.meta.totalAmount,
          pm_entries: response.meta.pm_entries,
        });
      }
    } catch (error) {
      this.setState({ is_loading_aucs: false });
    }
  };

  openApprove = (group, is_group = false) => {
    this.setState({
      open_approve_popup: true,
      selected_id: group.id,
      selectedRows: [],
      selected_group: group,
    });
    this.loadAllAuctions(`group=${group.id}`);
  };

  renderTableRow = (item, i) => (
    <tr key={`group-${i}`}>
      <td>{i + 1}</td>
      <td>{item?.organization_info?.organization_name}</td>
      <td>{item?.group_name}</td>
      <td>
        <button
          className="btn btn-info rounded-5 py-1 px-2"
          style={{ textWrap: "nowrap", cursor: "pointer" }}
          onClick={() => this.openApprove(item)}
        >
          {item?.total_auctons}
        </button>
      </td>
      <td>
        <button
          className="btn btn-warning rounded-5 py-1 px-2"
          style={{
            textWrap: "nowrap",
            cursor: "pointer",
          }}
          onClick={() => {
            this.openBiddersPopup(item);
          }}
        >
          {item?.total_enrolled}
        </button>
      </td>
      <td>{item?.end_date_formatted}</td>
      <td>
        <img
          src={item?.organization_info?.file_organization_image}
          alt={item?.organization_info?.organization_name}
          width={45}
        />
      </td>
    </tr>
  );

  render() {
    const {
      groups,
      groups_data,
      auctions,
      is_loading,
      selected_group,
      group_total,
      open_approve_popup,
      is_loading_aucs,
      client,
      end_time,
    } = this.state;

    return (
      <React.Fragment>
        <MzadLoader loading={is_loading} />

        <div className="d-flex align-items-center justify-content-start my-2 flex-wrap gap-2">
          <div className="form-group">
            <label className="form-label">{i18n.t("client")}</label>
            <select
              className="form-control"
              name="client"
              value={client}
              onChange={this.handleFilterChange}
            >
              <option value="">{i18n.t("clients")}</option>
              {groups_data.map((item, i) => (
                <option key={`client-${i}`} value={item?.organization}>
                  {item?.organization_info?.organization_name}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label className="form-label">{i18n.t("end_date")}</label>
            <input
              type="date"
              name="end_time"
              className="form-control"
              value={end_time}
              onChange={this.handleFilterChange}
            />
          </div>
        </div>

        {!is_loading && (
          <div className="table-responsive">
            <table className="table table-bordered table-hover table-striped">
              <thead className="thead-dark">
                <tr>
                  <th>{i18n.t("sl_no")}</th>
                  <th>{i18n.t("client_name")}</th>
                  <th>{i18n.t("group_name")}</th>
                  <th>{i18n.t("total_auctions")}</th>
                  <th>{i18n.t("total_bidders")}</th>
                  <th>
                    {i18n.t("auctions")} {i18n.t("end_date")}
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {groups.length > 0 ? (
                  groups.map(this.renderTableRow)
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center py-4">
                      {i18n.t("no_data_found")}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}

        <Modal
          show={open_approve_popup}
          onHide={() => this.setState({ open_approve_popup: false })}
          size="xl"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ width: "95%" }}>
              <div className="d-flex justify-content-between">
                <div style={{ fontSize: "1rem" }}>
                  {selected_group?.organization_info?.organization_name} (
                  {!is_loading_aucs &&
                    `${i18n.t("total_auctions")}: ${auctions.length}`}
                  )
                </div>
                {!is_loading_aucs && (
                  <div className="px-4" style={{ fontSize: "1rem" }}>
                    {i18n.t("total_amount")} {group_total.toFixed(2)}
                  </div>
                )}
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <MzadLoader loading={is_loading_aucs} />
            {!is_loading_aucs && auctions.length > 0 && (
              <ListAucsTable
                auctions={auctions}
                group={selected_group}
                group_info={this.state.group_info}
              />
            )}
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.open_bidder_popup}
          onHide={() => this.setState({ open_bidder_popup: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              {i18n.t("bidders")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <MzadLoader loading={this.state.bidder_loader} />
            {this.state.bidders && this.state.bidders.length > 0 && (
              <table className="table table-stripped">
                <thead>
                  <tr>
                    <th>
                      {i18n.t("name")} & {i18n.t("details")}
                    </th>
                    <th>{i18n.t("amount")}</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.bidders.map((item, i) => {
                    return (
                      <>
                        <tr>
                          <td>
                            {item.name}(
                            <small className="text text-dark">
                              USER ID : {item.user_id}
                            </small>
                            )<br />
                            <small className="text text-dark">
                              {i18n.t("bidder_id")} : {item.id}
                            </small>
                            <span>
                              {item.email && (
                                <>
                                  <br />
                                  <small className="text text-dark">
                                    {item.email}
                                  </small>
                                </>
                              )}
                              {item.mobile && (
                                <>
                                  <br />
                                  <small className="text text-dark">
                                    {item.mobile}
                                  </small>
                                </>
                              )}
                            </span>
                            <span>
                              <br />
                              <small className="text text-dark">
                                {i18n.t("auction")} : {item.title}
                              </small>
                            </span>
                          </td>
                          <td>
                            <SaudiRiyalLogo/>&nbsp;{item.bid_amount}
                          </td>
                        </tr>
                        <hr />
                      </>
                    );
                  })}
                </tbody>
              </table>
            )}
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}
